import { Flex } from "@aircall/tractor";

import { CsatDriver } from "@/components/CsatDriver";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

export function PlaygroundCsatDriver() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Positive driver (green arrow)
        </PlaygroundSubSectionTitle>
        <CsatDriver
          polarity="POSITIVE"
          label="Issue resolved and customer expressed thanks"
        />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Negative driver (red arrow)
        </PlaygroundSubSectionTitle>
        <Flex gap="xxs" flexDirection="column">
          <CsatDriver
            polarity="NEGATIVE"
            label="No confirmation of resolution, customer still frustrated at end of call"
          />
          <CsatDriver
            polarity="NEGATIVE"
            label="Customer asked to speak to a manager, indicating high effort"
          />
        </Flex>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
